export default __webpack_public_path__ + "static/media/4.11b11f0a.png";